<template>
    <div>

     <div v-if="formulario == 1">
        
      <div class="form-registro1">
        <main class="container registro p-5 d-flex justify-content-center">
            <form action="" class="p-5 c-d">
              <h2 class="titulo-registro text-center m-t-1">Hola {{nombreUsuario}}</h2>
              <p class="text-center">Necesitamos unos datos adicionales</p>
               <br>
               <h4 class="text-center m-b">Datos laborales</h4>
                <div class="row g-3">
                    <div class="col-md-12">
                      <label for="firstName" class="form-label">Tipo de trabajador</label>
                      <select class="form-select" aria-label="Default select example">
                        <option selected>--Seleccione--</option>
                        <option value="1" active>SI</option>
                        <option value="2">NO</option>
                      </select>
                    </div>
                    
                    <div class="col-md-12">
                      <label for="lastName" class="form-label">Profesión / Ocupación</label>
                      <input type="text" class="form-control" id="lastName" placeholder="" value="">
                    </div>
                   
                    <div class="col-md-12">
                      <label for="firstName" class="form-label">Tiempo de servicio</label>
                      <input type="text" class="form-control" id="" placeholder="" value="">
                    </div>
                  
                    <div class="col-md-12">
                      <label for="firstName" class="form-label">Ingreso anual</label>
                      <input type="text" class="form-control" id="" placeholder="" value="">
                    </div>
                   
                    <div class="col-md-12">
                      <label for="exampleFormControlInput1" class="form-label">Declaración jurada de origen de fondos</label>
                      <input type="text" class="form-control" id="" placeholder="" value="">
                    </div>              

                      <div class="col-md-12">
                        <label for="exampleFormControlInput1" class="form-label">Teléfono</label>
                        <input type="text" class="form-control" id="" placeholder="" value="">
                      </div>
                    
                    <div class="col-md-12 d-flex justify-content-end">
                    <button type="button" v-on:click="formulario += 1" class="btn btn-light">Siguiente <i class="fas fa-arrow-right"></i></button>
                  </div>
                </div>
            </form>
        </main>
    </div>
    </div>

  <div v-if="formulario == 2">
    
      <div class="form-registro1">
        <main class="container registro p-5 d-flex justify-content-center">
            <form action="" class="p-5 c-d">
              <h4 class="text-center">Dirección laboral</h4> <br>
                <div class="row g-3">
                  <div class="col-md-12">
                    <label for="exampleFormControlInput1" class="form-label">Pais</label>
                    <select class="form-select" aria-label="Default select example" id="Nacionalidad" v-model="registerForm.DatosPersonales.Nacionalidad">
                      <option selected>--Seleccione--</option>
                      <option v-for="(linea,index) in selectPais" :key="index" :value="linea.IdPais" v-text="linea.NombrePais" ></option>
                    </select>
                </div>
                    <div class="col-md-12">
                      <label for="firstName" class="form-label">Departamento</label>
                      <select class="form-select" aria-label="Default select example" v-model="registerForm.DireccionUsurio.Departamento" @change="obtenerSelectProvincia">
                        <option selected>--Seleccione--</option>
                        <option v-for="(linea,index) in selectDepartamento" :key="index" :value="linea.IdDepartamento" v-text="linea.NombreDepartamento" ></option>
                      </select>
                    </div>

                    <div class="col-md-12">
                        <label for="firstName" class="form-label">Provincia</label>
                        <select class="form-select" aria-label="Default select example" v-model="registerForm.DireccionUsurio.Provincia" @change="obtenerSelectDistrito">
                          <option selected>--Seleccione--</option>
                          <option v-for="(linea,index) in selectProvincia" :key="index" :value="linea.IdProvincia" v-text="linea.NombreProvincia" ></option>
                        </select>
                      </div>

                      <div class="col-md-12">
                        <label for="firstName" class="form-label">Distrito</label>
                        <select class="form-select" aria-label="Default select example" v-model="registerForm.DireccionUsurio.Distrito">
                          <option selected>--Seleccione--</option>
                           <option v-for="(linea,index) in selectDistrito" :key="index" :value="linea.IdDistrito" v-text="linea.NombreDistrito" ></option>
                        </select>
                      </div>
                    
                    <div class="col-md-12">
                      <label for="lastName" class="form-label">Dirección</label>
                      <input type="text" class="form-control" id="lastName" placeholder="Calle, Av, Jr" value="">
                    </div>
                   
                    <div class="col-md-6">
                      <input type="text" class="form-control" id="" placeholder="Mz, It" value="">
                    </div>
                  
                    <div class="col-md-6">
                      <input type="text" class="form-control" id="" placeholder="Int, Dpto" value="">
                    </div>
                   
                    <div class="col-md-12">
                      <input type="text" class="form-control" id="" placeholder="Urb" value="">
                    </div>   
                    </div>  
                    <br>          
                    <div class="">
                      <p class="text-center t-d">Dele guardar para continuar</p>
                      <button class="w-100 btn btn-lg btn btn-registro" type="button" @click="$router.push('operacion').catch(err => {})">Guardar</button>
                    </div> 
            </form>
        </main>
    </div>
    </div>



</div>
</template>

<script>

import auth from '@/services/auth'


  export default {
    name: "CompletarDatos",

    data() {
    return {
      formulario:1,
      nombreUsuario:localStorage.getItem("nombreUsuario"),
      parametrosGenerales:[],
      selectPais:[],
      selectDepartamento:[],
      selectProvincia:[],
      selectDistrito:[],
      registerForm: {
        DatosPersonales:{
          Nombres:"",
          Apellidos:"",
          Domiciliado:"",
          DocumentoIdentidad:"",
          FechaNacimiento:"",
          Nacionalidad:"",
          ExpuestaPoliticamente:"",
          Telefono:"",
          Celular:"",
          Email:"",
          Clave:"",
        },
        DireccionUsurio:{
          Calle_av_jr:"",
          N_mz_lt:"",
          Int_dpto:"",
          Urbanizacion:"",
          Provincia:"",
          Departamento:"",
          Distrito:"",
        }
      },
    };
  },

  beforeCreate(){
    helpers.actualizarTipoCambio(this);
    auth.listParametersGenerals().then(response => {
      this.parametrosGenerales=response;
      this.obtenerSelectDepartamento();
      this.obtenerSelectPais();
    });
  },
    methods:{
      obtenerSelectDepartamento(){
      this.selectDepartamento=this.parametrosGenerales[0].Departamento;
    },
    obtenerSelectPais(){
      this.selectPais=this.parametrosGenerales[0].Pais;
    },
    obtenerSelectProvincia(){
      this.selectProvincia=this.parametrosGenerales[0].Provincia.filter(e=>e.IdDepartamento==this.registerForm.DireccionUsurio.Departamento);

    },
    obtenerSelectDistrito(){
       this.selectDistrito=this.parametrosGenerales[0].Distrito.filter(e=>e.IdProvincia==this.registerForm.DireccionUsurio.Provincia);
    },
      
    },
  };
  </script>


// WEBPACK FOOTER //
// src/components/user/CompletarDatos.vue